import styled from "styled-components";

import { IThemeProps } from "@/styles";
import { fadeIn, moveUpAndFadeIn } from "@/styles/Mixins";

const MeterSVG = styled.svg`
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    height: 350px;
  }
`;

const MeterQuestions = styled.div`
  display: flex;
  justify-content: space-between;
  padding-left: 20px;
  padding-right: 20px;
  margin-top: -30px;
  margin-bottom: 16px;
  min-height: 50px;
`;

const MeterAnswerLeft = styled.div`
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  width: 40%;
  text-align: left;
  line-height: 1.4;
  color: ${(props: any) => props.theme.colors.black};
  font-size: ${(props: any) => props.theme.typography.h400};
  h1 {
    font-size: ${(props: any) => props.theme.typography.h800};
    color: ${(props: any) =>
      props.theme.thesis.hasPrimaryPrio
        ? props.theme.colors.primary
        : props.theme.colors.secondary};
    text-transform: uppercase;
    margin-bottom: 5px;
  }
  @media ${(props: any) => props.theme.breakpoints.mobile} {
    font-size: ${(props: any) => props.theme.typography.h200};
    h1 {
      font-size: ${(props: any) => props.theme.typography.h500};
    }
  }
`;

const MeterAnswerRight = styled(MeterAnswerLeft)`
  text-align: right;
`;

const MeterWrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  background: ${(props: IThemeProps) => props.theme.colors.defaultBackground};
  touch-action: none;

  .meterTitle {
    font-size: 30px;
    text-align: center;
    padding-left: 6%;
    padding-right: 6%;
  }

  .meterResultText {
    width: 29px;
    height: 19px;
    font-size: 21px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
  }

  .meterQuestions {
    display: flex;
    justify-content: space-between;
    padding-left: 6%;
    padding-right: 6%;
    margin-top: -20px;
    margin-bottom: 16px;

    .meterQuestionLeft,
    .meterQuestionRight,
    p,
    h1,
    h2,
    h3,
    h4,
    strong {
      font-size: 14px;
      font-stretch: condensed;
      margin-top: 8px;
      margin-bottom: 8px;
    }

    .meterQuestionLeft {
      width: 40%;
    }

    .meterQuestionRight {
      width: 40%;
      text-align: right;
    }

    strong,
    h1 {
      display: block;
      font-size: 25px;
    }

    strong,
    h1,
    h2,
    h3,
    h4 {
      color: ${(props: any) =>
        props.theme.thesis.hasPrimaryPrio
          ? props.theme.colors.primary
          : props.theme.colors.secondary};
    }
  }

  .meterIntroWrapper {
    position: absolute;
    top: 170px;
    padding-left: 6%;
    padding-right: 6%;
    width: 100%;

    .meterIntro {
      overflow: hidden;
      position: relative;
      background-color: ${(props: any) => props.theme.colors.white};
      max-width: 500px;
      margin-left: auto;
      margin-right: auto;
      border-radius: 20px;
      box-shadow: ${(props: any) => props.theme.shadows.s200};

      .meterIntroText {
        padding: 40px 16px;

        .meterIntroHeader {
          font-size: ${(props: any) => props.theme.typography.h700};
          text-align: center;
        }

        .meterIntroSubheader {
          color: #666666;
          font-size: ${(props: any) => props.theme.typography.h500};
          text-align: center;
          margin-top: 20px;
        }
      }
    }
  }

  .meterButtonClose {
    top: 16px;
    right: 16px;
    position: absolute;
    cursor: pointer;
  }

  .meterButtonOk {
    position: absolute;
    top: 0;
    right: 0;

    span {
      margin: 10px;
      cursor: pointer;
    }
  }

  .meterEditorialOpinionWrapper {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${(props: any) => props.theme.colors.overlay};
    animation: ${fadeIn} 350ms ease-in;

    .meterEditorialOpinion {
      position: relative;
      text-align: center;
      background-color: ${(props: any) => props.theme.colors.white};
      cursor: pointer;
      overflow: hidden;
      width: 100%;
      max-width: 400px;
      margin-left: auto;
      margin-right: auto;
      padding: ${(props: any) => props.theme.spacing.desktop.s500}px;
      border: 3px solid ${(props: any) => props.theme.colors.primary};
      opacity: 0;
      animation: ${moveUpAndFadeIn({ size: "50px" })} 250ms linear;
      animation-delay: 500ms;
      animation-fill-mode: forwards;

      .meterEditorialOpinionText {
        .meterEditorialOpinionName {
          color: #1d1d1d;
          font-size: ${(props: any) => props.theme.typography.h500};
          font-weight: 600;
          font-stretch: condensed;
          text-align: center;
          padding-right: 10px;
          vertical-align: middle;
        }

        .meterEditorialOpinionDescription {
          display: flex;
          flex-direction: row;
          font-size: ${(props: any) => props.theme.typography.h600};
          align-items: center;
          text-align: center;
          padding-bottom: ${(props: any) => props.theme.spacing.desktop.s500}px;
        }

        .meterEditorialIcon {
          display: flex;
          margin-right: ${(props: any) => props.theme.spacing.desktop.s100}px;
          img {
            width: 69px;
            height: 69px;
            border-radius: 99999px;
            vertical-align: middle;
          }
        }

        .meterEditorialNameIconWrapper {
          margin-bottom: 17px;
          margin-top: 12px;
        }
      }
    }
  }

  .meterPulse {
    cursor: pointer;
    animation: compassPulse 1s linear infinite;
  }

  .meterPulse:hover {
    animation: none;
  }

  .meterHandleTouched {
    transform: scale(1.1);
  }

  @keyframes compassPulse {
    0% {
      transform: scale(1);
    }

    50% {
      transform: scale(1.24);
    }

    100% {
      transform: scale(1);
    }
  }
`;

const Flexbox = styled.div`
  position: relative;
`;

const InnerBox = styled.div`
  position: relative;
  padding: 10px;
  max-width: ${(props: any) => props.theme.globals.maxInteractionWidth};
  min-height: ${(props: any) => props.theme.globals.minInteractionHeight};
  margin: 0 auto;
  @media ${(props: any) => props.theme.breakpoints.mobile} {
    min-height: auto;
  }
`;

const WhiteBox = styled.div`
  position: relative;
  background-color: ${(props: any) => props.theme.colors.white};
  overflow: hidden;
  min-height: inherit;
  border-radius: ${(props: any) => props.theme.borders.interaction || "0px"};
`;

const EditorialOpinionText = styled.span`
  font-size: ${(props: any) => props.theme.typography.h600};
  @media ${(props: any) => props.theme.breakpoints.mobile} {
    font-size: ${(props: any) => props.theme.typography.h400};
  }
`;

export {
  EditorialOpinionText,
  Flexbox,
  InnerBox,
  MeterAnswerLeft,
  MeterAnswerRight,
  MeterQuestions,
  MeterSVG,
  MeterWrapper,
  WhiteBox,
};
